import sidebar from '@/config/sidebars/formTracking'
import createVueApp from '@/common/createApp'

Styxie.Initializers.FormTrackingSubmits = {
  index: async(props) => {
    const { default: SubmitsIndex } = await import('@/vue_widgets/form_tracking/submits/index.vue')
    createVueApp(SubmitsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: SubmitsShow } = await import('@/vue_widgets/form_tracking/submits/show.vue')
    createVueApp(SubmitsShow, { props, sidebar })
  }
}
